<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'Checkbox label'
            },
            value: {
                type: Boolean | String | Number
            },
        },
        data() {
            return {
                isChecked: typeof this.value === "boolean" ? this.value : ('true' === this.value || 1 === this.value),
            }
        },
        watch: {
            isChecked(newValue) {
                this.$emit('input', newValue);
            }
        },
    }
</script>

<template>
        <div class="i-checks">
            <label :for="'chk'+label">
                <input :id="'chk'+label" type="checkbox" v-model="isChecked" />

                <slot name="label">
                    <span v-text="label"></span>
                </slot>
            </label>
            <slot name="afterLabel"></slot>
        </div>
</template>
